import oRequest from '@/libsV2/request.js';
const URL = {
    MODULE_ALL:'board/index/channel',//统计模块
    AUTH:'/board/indexv2/auth',//权限判断
    // 开发者
    MODULE_SINGLE:'board/indexv2/overview',//开发者总览数据
    BORD_MAP_CITY:'board/indexv2/map',//口碑地图大区维度数据
    BORD_MAP_CONTENT:'board/indexv2/topicpage',//口碑地图大口碑内容维度数据
    MAP_CASE:'board/indexv2/mapview',//口碑地图案例数据
    VERTICAL_MEDIUM:'board/indexv2/vertical',//垂媒数据
    PRODUCT_CITY:'board/indexv2/goods',//产品中心大区维度信息
    PRODUCT_CONTENT:'board/indexv2/goodspage',//产品内容维度数据
    // 管理看板
    MODULE_SINGLE_MANAGE:'board/indexv2/managerview',//管理员总览数据
    BEHAVIOR:'board/indexv2/behavior',//靓导购
    PRAISE:'board/indexv2/praise',//智慧案例发布数据
    JF_DATA:'board/indexv2/jiaofudata',//智慧集成交付数据
    PROJECT_PRAISE:'board/indexv2/projectpraise',//智慧集成系统口碑数据
    PROJECT_VIEW:'board/indexv2/projectview',//智慧集成系统口碑数据--表格
    JF_SYSTEM:'board/indexv2/jiaofudata',//智慧集成交付数据
    CONFIG:'/board/indexv2/managerconfig',//大区,省份筛选配置
    CONFIG_AREA:'/board/indexv2/areaconfig',//直销员大区,省份筛选配置
    // 直销员
    MODULE_SINGLE_DIRECT:'/board/indexv2/directview',//直销员总览数据
    USER_BEHAVIOR:'board/indexv2/userbehavior',//客户行为
    WISDOM_MAP:'board/indexv2/delivery',//直销员智慧集成口碑数据
    CATEGORY:'board/indexv2/category',//分品类榜单
    CATEGORY_INFO:'board/indexv2/categorypage',//分品类详情接口
    DEAL_POST:'/board/index/deal',//提交备注
    REPORT:'/board/indexv2/behavior2',//数据报表
}

export default{
    report(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.REPORT,oData)
    },
    moudeleSingleDirect(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.MODULE_SINGLE_DIRECT,oData)
    },
    moudeleSingleManage(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.MODULE_SINGLE_MANAGE,oData)
    },
    auth(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.AUTH,oData)
    },
    dealPost(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.DEAL_POST,oData)
    },
    categoryInfo(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.CATEGORY_INFO,oData)
    },
    config(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.CONFIG,oData)
    },
    configArea(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.CONFIG_AREA,oData)
    },
    category(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.CATEGORY,oData)
    },
    jfSystem(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.JF_SYSTEM,oData)
    },
    projectView(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.PROJECT_VIEW,oData)
    },
    projectParise(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.PROJECT_PRAISE,oData)
    },
    jfData(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.JF_DATA,oData)
    },
    wisdomMap(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.WISDOM_MAP,oData)
    },
    userBehavior(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.USER_BEHAVIOR,oData)
    },
    praise(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.PRAISE,oData)
    },
    behavior(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.BEHAVIOR,oData)
    },
    productContent(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.PRODUCT_CONTENT,oData)
    },
    productCity (data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.PRODUCT_CITY,oData)
    },
    verticalMedium(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.VERTICAL_MEDIUM,oData)
    },
    mapCase(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.MAP_CASE,oData)
    },
    bordMapContent(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.BORD_MAP_CONTENT,oData)
    },
    bordMapCity(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.BORD_MAP_CITY,oData)
    },
    allModule(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.MODULE_ALL,oData)
    },
    singleModule(data={}){
        let oData = Object.assign({},data,{is_es:1});
        return oRequest.getData(URL.MODULE_SINGLE,oData)
    },
}
